import { Link } from 'react-router-dom';

const NutrareFooter = () => {
  return (
    <footer className="bg-gradient-to-br from-orange-500 via-amber-500 to-orange-600 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Logo e Descrição */}
          <div>
            <img
              src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/ac435f6d5b1a7055bcf07f711dd158e1.png"
              alt="Nutrare"
              className="h-20 w-auto mb-4"
            />
            <p className="text-white/90 leading-relaxed">
              Produtos essenciais para o dia a dia, com qualidade superior e preços acessíveis.
            </p>
          </div>

          {/* Categorias */}
          <div>
            <h3 className="text-xl font-bold mb-4">Categorias</h3>
            <ul className="space-y-3">
              <li className="text-white/90">Achocolatado</li>
              <li className="text-white/90">Bebida</li>
              <li className="text-white/90">Caldo</li>
              <li className="text-white/90">Gelatina</li>
              <li className="text-white/90">Mingau</li>
              <li className="text-white/90">Purê</li>
              <li className="text-white/90">Risoto</li>
              <li className="text-white/90">Sopa</li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contato</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-line text-xl mr-3 mt-1 flex-shrink-0"></i>
                <a
                  href="https://wa.me/5519998928137"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  (19) 99892-8137
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-xl mr-3 mt-1 flex-shrink-0"></i>
                <span className="text-white/90">contato@nutrare.com.br</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-xl mr-3 mt-1 flex-shrink-0"></i>
                <span className="text-white/90">
                  São Paulo, Brasil
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Redes Sociais */}
        <div className="border-t border-white/20 pt-8 mb-8">
          <div className="flex justify-center gap-6">
            <a
              href="https://wa.me/5519998928137"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-orange-700/30 py-6">
          <p className="text-center text-orange-100 text-sm">
            © 2024 Nutrare - Todos os direitos reservados |{' '}
            <a
              href="https://wa.me/5519998928137"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors cursor-pointer"
            >
              M.PLACIDINO
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default NutrareFooter;
